import React, { useEffect, useRef } from 'react';
import { METRIC_COLUMN_OPTIONS, METRIC_OPERATOR_OPTIONS, EMPTY_METRIC_FILTER } from './filterOptions';

/**
 * Column / operator / value editor for the metric filter.
 * Edits apply live (matching the previous behaviour); "Done" just closes.
 */
const MetricFilterPopover = ({ dataFilter, onChange, onClose }) => {
    const columnRef = useRef(null);

    useEffect(() => {
        columnRef.current?.focus();
    }, []);

    const update = (patch) => onChange({ ...dataFilter, ...patch });
    const isComplete = Boolean(dataFilter.column && dataFilter.value !== '');

    return (
        <div className="metric-filter-popover">
            <div className="filter-popover__section">
                <label className="filter-popover__field-label" htmlFor="metric-filter-column">Column</label>
                <select
                    id="metric-filter-column"
                    ref={columnRef}
                    className="filter-popover__select"
                    value={dataFilter.column}
                    onChange={(event) => update({ column: event.target.value })}
                >
                    <option value="">Select a column</option>
                    {METRIC_COLUMN_OPTIONS.map((option) => (
                        <option key={option.value} value={option.value}>{option.label}</option>
                    ))}
                </select>
            </div>

            <div className="filter-popover__section metric-filter-popover__row">
                <div>
                    <label className="filter-popover__field-label" htmlFor="metric-filter-operator">Condition</label>
                    <select
                        id="metric-filter-operator"
                        className="filter-popover__select"
                        value={dataFilter.operator}
                        onChange={(event) => update({ operator: event.target.value })}
                    >
                        {METRIC_OPERATOR_OPTIONS.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                        ))}
                    </select>
                </div>
                <div>
                    <label className="filter-popover__field-label" htmlFor="metric-filter-value">Value</label>
                    <input
                        id="metric-filter-value"
                        type="number"
                        className="filter-popover__input"
                        placeholder="0"
                        value={dataFilter.value}
                        onChange={(event) => update({ value: event.target.value })}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter' && isComplete) onClose();
                        }}
                    />
                </div>
            </div>

            <div className="filter-popover__footer">
                <button
                    type="button"
                    className="filter-popover__btn"
                    onClick={() => onChange({ ...EMPTY_METRIC_FILTER })}
                    disabled={!dataFilter.column && dataFilter.value === ''}
                >
                    Reset
                </button>
                <div className="filter-popover__footer-actions">
                    <button type="button" className="filter-popover__btn is-primary" onClick={onClose}>
                        Done
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MetricFilterPopover;
